import { toast } from 'react-toastify';

import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestOperacoes({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'operacoes', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* deleteOperacao({ payload }) {
  try {
    const { idoperacao, params } = payload;

    yield call(api.delete, `operacoes/${idoperacao}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* store({ payload }) {
  try {
    const { operacao, params } = payload;

    yield call(api.post, 'operacoes', operacao);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/operacoes');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* find({ payload }) {
  try {
    const { idoperacao } = payload;

    const { data } = yield call(api.get, `operacoes/${idoperacao}`);
    yield put(successRequest(data));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* update({ payload }) {
  try {
    const { operacao, params } = payload;

    yield call(api.put, 'operacoes', operacao);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/operacoes');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;

    const response = yield call(api.get, 'operacoes', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export default all([
  takeLatest('@operacao/OPERACOES_IN_REQUEST', requestOperacoes),
  takeLatest('@operacao/DELETE_OPERACAO', deleteOperacao),
  takeLatest('@operacao/SUCCESS_REMOVE', requestOperacoes),
  takeLatest('@operacao/STORE_OPERACAO', store),
  takeLatest('@operacao/FIND_OPERACAO', find),
  takeLatest('@operacao/UPDATE_OPERACAO', update),
  takeLatest('@operacao/RECORD_FILTERING', applyedFilters),
]);
